<template>
    <div :class="{ 'menu-open': $store.state.isMenuOpen }" :style="{ 'margin-right': $store.state.isMenuOpen ? '25%' : '0%' }"> <!-- Aqui solução do layout! -->

      <h1>Consultar Processual - Busca de Processo - Chave de Acesso</h1>

        <div class="row tamanho">
            <div class="col-3">
                <label>Nº Processo<span class="asterisco">*</span></label>
                <input type="text" class="form-control" v-model="num_processo" maxlength="12">
            </div>
            <div class="col-3">
                <label>Chave Documento<span class="asterisco">*</span></label>
                <input type="text" class="form-control" v-model="chave_processo" maxlength="12">
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-12">
                <img :src="caminhoImagemAleatoria.src" :alt="caminhoImagemAleatoria.alt" :data-id="caminhoImagemAleatoria.description">
                <img :src='BASE_URL+"imagens/captcha/icone_ouvir.jpg"' alt="" /><br />
                <input type="text" class="form-control" id="recaptcha_digitado" style="width: 120px; margin-top: 2px;" v-model="recaptcha_digitado" ref="recaptcha_digitado">

            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div style="text-align: right; width: 100%;" class="mb-5 mt-2">
                    <button type="button" class="btn btn-sm btn-light" style="margin-right: 3px; width: 85px; cursor: pointer; background-color: #007BFF;" @click="BuscarProcesso();">
                    <label style="color: white; vertical-align: middle; cursor: pointer;">Consultar</label>
                </button>
                </div>

            </div>
        </div>


    </div>
  </template>
  
  <script>

//Continuar aqui - Ainda não foi criado a chamada dessa tela nem a rota pra ela.

export default {
    data() {
        return {
            BASE_URL: window.Laravel.baseUrl,
            num_processo: '',
            chave_processo: '',

            imagens_captcha: [
                    { id: 1, src: "imagens/captcha/6WGF.jpg", alt: "6WGF", description: "6WGF" },
                    { id: 2, src: "imagens/captcha/FUNM.jpg", alt: "FUNM", description: "FUNM" },
                    { id: 3, src: "imagens/captcha/KTPO.jpg", alt: "KTPO", description: "KTPO" },
                    { id: 3, src: "imagens/captcha/L9CB.jpg", alt: "L9CB", description: "L9CB" },
                    { id: 3, src: "imagens/captcha/O9DD.jpg", alt: "O9DD", description: "O9DD" },
                    { id: 3, src: "imagens/captcha/RHMM.jpg", alt: "rhmm", description: "rhmm" },
                ],
            caminhoImagemAleatoria: {},
            recaptcha_digitado: '',

        };
    },
    methods: {
        BuscarProcesso() {
            if (this.num_processo === "") {
                alert("Campo Nº Processo não pode ser vazio.");
                return;
            }

            if (this.chave_processo === "") {
                alert("Campo Chave Documento não pode ser vazio.");
                return;
            }

            if (this.recaptcha_digitado === '') {
                alert('Informe o código de confirmação');
                this.$refs.recaptcha_digitado.focus();
                return;
            }
            
            if (this.caminhoImagemAleatoria.description != this.recaptcha_digitado) {
                alert('Código da imagem (captcha) incorreto.');
                return;
            }


            const url = `${this.BASE_URL}processos/verifica_chave/${this.chave_processo}`;

            axios.get(url)
                .then(response => {
                    if (response.data.exists) {
                        window.location.href = `${this.BASE_URL}processos/consulta_chave/${this.chave_processo}`;
                    } else {
                        alert("Chave não encontrada.");
                    }
                })
                .catch(error => {
                    console.error('Erro na busca:', error);
                    alert("Ocorreu um erro ao buscar a chave do processo.");
                });
        },
        selecionarImagemAleatoria() {
            const indiceAleatorio = Math.floor(Math.random() * this.imagens_captcha.length);
            this.caminhoImagemAleatoria = this.imagens_captcha[indiceAleatorio];
            this.caminhoImagemAleatoria.src = this.BASE_URL + this.caminhoImagemAleatoria.src; 
        },
    },
    mounted() {
        this.selecionarImagemAleatoria();
    },
    
};
</script>
  
  <style scoped>
  h1{
      font-size: 26px;
  }
  
  .form-container {
      border: 1px solid gray; /* Borda fina cinza */
      padding: 10px;
      position: relative; /* Posição relativa para o posicionamento do título */
      margin-top: 5px; /* Espaçamento superior para visualização do título */
      margin-left: 5px;
      margin-right: 5px;
      border-radius: 5px;
      background-color: #FFFFFF;
  }
  
  .form-title {
      position: absolute; /* Posicionamento absoluto do título */
      top: -15px; /* Posiciona o título acima da borda */
      left: 10px; /* Espaçamento da esquerda para o título */
      background: white; /* Fundo branco para o título */
      padding: 0 1px; /* Espaçamento interno do título */
      font-weight: bold;;
  }
  
  .asterisco{
    color: red;
  }

  .tamanho{
    font-size: small;
  }

  </style>
